// SEP 911 — Regiones/países de origen para alumnos con escuela previa en el extranjero
export const PAISES_REGIONES = [
  { value: "ESTADOS_UNIDOS", label: "Estados Unidos" },
  { value: "CANADA", label: "Canadá" },
  { value: "CENTROAMERICA_CARIBE", label: "Centroamérica y el Caribe" },
  { value: "SUDAMERICA", label: "Sudamérica" },
  { value: "AFRICA", label: "África" },
  { value: "ASIA", label: "Asia" },
  { value: "EUROPA", label: "Europa" },
  { value: "OCEANIA", label: "Oceanía" },
];

export const labelPaisRegion = (v) =>
  PAISES_REGIONES.find((p) => p.value === v)?.label || v || "—";
